import React from "react";
import ContentTableData from "./ContentTableData";
import { Button, Space } from "antd";
import { NavLink } from "react-router-dom";
import { useContext } from "react";
import { context } from "../../context/context";
const Contents = () => {
    const {
        setContentId,
        setTextEditorHTML,
        setLinkTags,
        setAddPhonePlace,
        setAddNamePlace,
        setEditedCategory,
        setEditedCity,
        setEditedCountry,
        setEditedProvince,
        setEditedSubCategory,
        setIsCategorySelected,
        setIsProvinceSelected,
        setIsCountrySelected,
        setPlaceFormTag,
        setCoverPic,
        setCoverPicId,
        setFileList,
        setFileListIds,
        setSelectedCategoryId,
        setSelectedCityId,
    } = useContext(context);
    const handleEmptyState = () => {
        setContentId("");
        setTextEditorHTML("");
        setPlaceFormTag([]);
        setLinkTags([]);
        setAddPhonePlace("");
        setAddNamePlace("");
        setEditedCategory();
        setEditedCity();
        setEditedCountry();
        setEditedProvince(null);
        setEditedSubCategory();
        setIsCategorySelected(false);
        setIsProvinceSelected(false);
        setIsCountrySelected(false);
        setCoverPic([]);
        setCoverPicId();
        setFileList([]);
        setFileListIds([]);
        setSelectedCategoryId();
        setSelectedCityId();
    };
    return (
        <>
            <Space
                direction="vertical"
                style={{ width: "100%", justifyContent: "space-between" }}
                align="end"
            >
                <NavLink to="/addContent">
                    <Button onClick={handleEmptyState} type="primary">
                        اضافه کردن محتوا جدید
                    </Button>
                </NavLink>
            </Space>
            <ContentTableData />
        </>
    );
};

export default Contents;
